import http from "@/http-common"

class VatRateDataService {
    getAll(url) {
        return http.get(`vat_rates${ url }`)
    }

    get(id) {
        return http.get(`vat_rates/${ id }`)
    }

    post(data) {
        return http.post('vat_rates', data)
    }

    patch(id, data, headers) {
        return http.patch(`vat_rates/${ id }`, data, headers)
    }

    delete(id) {
        return http.delete(`vat_rates/${ id }`)
    }
}

export default new VatRateDataService()